import { Table } from "antd";
import { ManageConversionPixelDrawer } from "components/Drawers/ManageConversionPixelDrawer/ManageConversionPixelDrawer.tsx";
import { useDrawer } from "hooks/useDrawer.ts";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { DrawerId } from "types/models.ts";

type ConversionType = "initiation" | "lead" | "prospect" | "sale" | "custom";

interface ConversionPixelData {
    key: string;
    name: string;
    type: ConversionType;
    action: string | null;
    note: string;
    required?: boolean;
}

export const ConversionPixelsTable = () => {
    const { t } = usePaldockTranslation("tables.conversion-pixels");
    const drawerUtils = useDrawer();

    const conversionPixelsData: ConversionPixelData[] = [
        {
            key: "initiation",
            name: t("types.initiation"),
            type: "initiation",
            action: null,
            note: t("notes.initiation"),
            required: true,
        },
        {
            key: "lead",
            name: t("types.lead"),
            type: "lead",
            action: t("actions.update_only"),
            note: t("notes.default"),
        },
        {
            key: "prospect",
            name: t("types.prospect"),
            type: "prospect",
            action: t("actions.create_update"),
            note: t("notes.default"),
        },
        {
            key: "sale",
            name: t("types.sale"),
            type: "sale",
            action: t("actions.create_update"),
            note: t("notes.default"),
        },
        {
            key: "custom",
            name: t("types.custom"),
            type: "custom",
            action: t("actions.create_update"),
            note: t("notes.default"),
        },
    ];

    const columns = [
        {
            title: t("columns.name"),
            dataIndex: "name",
            key: "name",
            width: "20%",
            render: (text: string, record: ConversionPixelData) => (
                <span>
                    {text}
                    {record.required && <span className="text-red-500">*</span>}
                </span>
            ),
        },
        {
            title: t("columns.action"),
            dataIndex: "action",
            key: "action",
            width: "15%",
            render: (text: string | null) => text || "-",
        },
        {
            title: t("columns.note"),
            dataIndex: "note",
            key: "note",
            width: "55%",
        },
    ];

    const handleRowClick = (record: ConversionPixelData) => {
        drawerUtils.show(DrawerId.ManageConversionPixel, {
            [`${DrawerId.ManageConversionPixel}-type`]: record.type,
        });
    };

    return (
        <>
            <ManageConversionPixelDrawer />
            <Table
                dataSource={conversionPixelsData}
                columns={columns}
                pagination={false}
                size="small"
                scroll={{ y: 300 }}
                onRow={(record) => ({
                    onClick: () => handleRowClick(record),
                    className: "cursor-pointer hover:bg-gray-50",
                })}
            />
        </>
    );
};
